import apiClient from "config/apiClient";
import {
  MstItemDetailTireTiresizeAspectRatioSelectResponse,
  MstItemDetailTireTiresizeRimDiamSelectResponse,
  MstItemDetailTireTiresizeWidthSelectResponse,
} from "../types/tire";

/**
 * Get tire size width list
 */
const getTiresizeWidthListApi = async () => {
  const res = await apiClient.post<MstItemDetailTireTiresizeWidthSelectResponse>(
    "/mst/item/detail/tire/tiresize/width/select",
    {},
  );
  return {
    list: res.data?.list ?? [],
  };
};

/**
 * Get tire size aspect ratio list
 * @param body - Object containing tire_width
 */
const getTiresizeAspectRatioListApi = async (body: { tire_width: number }) => {
  const res = await apiClient.post<MstItemDetailTireTiresizeAspectRatioSelectResponse>(
    "/mst/item/detail/tire/tiresize/aspect/ratio/select",
    body,
  );
  return {
    list: res.data?.list ?? [],
  };
};

/**
 * Get tire size rim diameter list
 * @param body - Object containing tire_width and tire_aspect_ratio
 */
const getTiresizeRimDiamListApi = async (body: {
  tire_width: number;
  tire_aspect_ratio: number;
}) => {
  const res = await apiClient.post<MstItemDetailTireTiresizeRimDiamSelectResponse>(
    "/mst/item/detail/tire/tiresize/rim/diam/select",
    body,
  );
  return {
    list: res.data?.list ?? [],
  };
};

export { getTiresizeWidthListApi, getTiresizeAspectRatioListApi, getTiresizeRimDiamListApi };
